import { ButtonBase, ButtonBaseProps, useTheme } from '@mui/material';
import { useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { ROUTES } from '../../../constants/routes';

interface NavigationItemProps extends ButtonBaseProps {
  item?: {
    path: string;
    label: string;
  };
}

const NavigationItem = ({ item, children, ...props }: NavigationItemProps) => {
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();
  const currentPathPart = useMemo(() => {
    const pathPart = location.pathname.split('/')[1];
    return pathPart ? `/${pathPart}` : ROUTES.DASHBOARD;
  }, [location.pathname]);

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (item) {
      navigate(item.path);
    } else {
      props.onClick?.(e);
    }
  };

  return (
    <ButtonBase
      {...props}
      component="button"
      onClick={handleClick}
      sx={{
        py: 2,
        px: 2,
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-start',
        cursor: 'pointer',
        gap: 1,
        color: currentPathPart === item?.path
          ? theme.palette.pink[500]
          : theme.palette.common.white,
        '&:hover': {
          backgroundColor: 'rgba(255, 255, 255, 0.08)',
        },
        position: 'relative',
        ...(currentPathPart === item?.path && {
          '&::before': {
            content: '""',
            position: 'absolute',
            left: 0,
            top: '50%',
            transform: 'translateY(-50%)',
            width: 3,
            height: '50%',
            backgroundColor: theme.palette.pink[500],
          },
        }),
      }}
    >
      {children}
    </ButtonBase>
  );
};

export default NavigationItem;